import { combineEpics, ofType } from 'redux-observable';
import { switchMap, map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { LanguagesAction } from './reducer';
import * as actions from './actions';
import { ILanguageData } from '.';

const API_URL = 'https://interview-ste.azurewebsites.net/languages';

const fetchLanguagesEpic = (action$: Observable<LanguagesAction>): Observable<LanguagesAction> => {
	return action$.pipe(
		ofType(actions.FETCH_LANGUAGES_INIT),
		switchMap(action => 
			ajax.getJSON(API_URL).pipe(
				map((response: ILanguageData[]) => actions.fetchLanguagesSuccess(response)),
				catchError(error =>  {
					let message: string;
					if (error.xhr) {
						message = `Error ${error.xhr.status} : ${error.xhr.statusText}`;
					} else if (error.message) {
						message = error.message;
					}

					message = message! || "Unkown error";					
					return of(actions.fetchLanguagesFailure(message));
				})
			)
		)
	);
};

const languagesEpic = combineEpics(fetchLanguagesEpic);
export default languagesEpic;



// WEBPACK FOOTER //
// ./src/store/modules/languages/epic.ts